import React from "react";
import { BlockLabel, getBlockLabelProps } from "oolib"

import GallerySlider from "./comps/GallerySlider";
import { SingleImageInput } from "./comps/SingleImageInput";
import { InlineImageInput } from "./comps/InlineImageInput";
import { ImageInputContextProvider } from "./ImageInputContext";
import { _Locale as localize } from "@/components/locale/Locale";

import { ProfileImageInput } from "./derivedComps/ProfileImageInput";

/**
 * maybe should pass uploading placeholders for gallery thumbnails from gallery slider (just like its done for slider shell)
 * 
 * stuff that needs to move to oolib if we wanna migrate this comp to oolib:
 * - bannerContext
 * - richInputHasValue (util)
 * - RichTextEditor
 */

export function ImageInput({
  id,
  value,
  onChange,
  readOnly,
  multiple,
  stretchToFullHeight = false,
  aspectRatio = '5/3',
  containerShape = 'rectangle', //alt = circle
  invert,
  enableCaptions = true,
  imageTags,
  defaultImageSpread = 'contain',
  allowedFormats = ["jpg", "jpeg", "png"],
  folderName = 'images',
  bucketEnv,
  formatConvertConfig,
  dropzoneLabel,
  dropzoneSublabel,
  disableImageBorder = false,
  omitEditorTools = [], //can include : 'cover_contain' | 'rotate' | 'reposition'
  isRequired,
  showImageUploadCaution ={} ,

  files, //used by RTEImageInput
  isInRTE
}){
  const props = arguments[0]

  const showOptionalLabelInDropzone = !props.label && !props.sublabel

  return (
    <ImageInputContextProvider
      {...{
        value,
        onChange,
        id,
        allowedFormats,
        formatConvertConfig,
        folderName,
        bucketEnv,
        multiple,
        aspectRatio,
        readOnly,
        enableCaptions,
        imageTags,
        defaultImageSpread,
        invert,
        containerShape,
        stretchToFullHeight,
        disableImageBorder,
        omitEditorTools,
        dropzoneLabel:
          dropzoneLabel || (multiple ? `${localize('Add Images here')}` :  "Add Image"),
        dropzoneSublabel:
          dropzoneSublabel ||
          `Supports: ${allowedFormats.map((f) => f.toUpperCase()).join(", ")}`,
        showOptionalLabelInDropzone, // in cases like cover image scenario, we wanna show the 'optional' label in the dropzone area, rather than label area
        isRequired,
        
        files,
        isInRTE,
        showImageUploadCaution,
      }}
    >
      <div style={{height: stretchToFullHeight ? "100%" : "auto",}}>
      <BlockLabel 
        {...getBlockLabelProps({
            ...props,
            hideOptionalLabel: showOptionalLabelInDropzone 
          })} 
        />
      {multiple ? (
        <GallerySlider />
      ) : isInRTE
        ? <InlineImageInput/> 
        : (
        <SingleImageInput value={value && value[0]} />
      )}
      </div>
    </ImageInputContextProvider>
  );
};


export { ProfileImageInput }